import { makeVar } from "@apollo/client"

import type { OutfitterFormBuilderDraft } from "~components/forms/outfitter-form-builder-draft-types"

export const ASSISTANT_OUTFITTER_FORM_DRAFT_STATE_KEY =
    "assistantOutfitterFormDraft"

/** `null` formId means the user is on the new outfitter form builder. */
export const ASSISTANT_NEW_OUTFITTER_FORM_ID = null

export type PendingOutfitterFormAssistantDraft = {
    /** A real form id when editing, or `null` for the new-form builder. */
    readonly formId: string | null
    readonly toolCallId: string
    readonly draft: OutfitterFormBuilderDraft
}

export const pendingOutfitterFormAssistantDraftVar =
    makeVar<PendingOutfitterFormAssistantDraft | null>(null)
